import _ from "lodash";
import React from "react";
import { withRouter } from "react-router";
import { compose } from "lib/apolloClient";
import Loading from "UIComponents/Loading";
import Toastr from "UIComponents/Toastr";
import PersistentNotification from "UIComponents/PersistentNotification";
import I18nHOC from "UIComponents/I18nHOC";
import ACLStore from "lib/aclStore";
import NetworkStatus from "UIComponents/NetworkStatus";
import NetworkStatusV2 from "UIComponents/NetworkStatusV2";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import PictureInPicture from "UIComponents/PictureInPicture";
import withPublicToken from "UIComponents/WithPublicToken";
import "styles/core.scss";
import classes from "./LoginView.scss";
import LoginPage from "./LoginPage";
import AddChildPage from "./AddChildPage";
import AddChildPageV2 from "./AddChildPageV2";
import ChildrenPage from "./ChildrenPage";
import ClassInviteChildSelection from "./FamilyInviteChildSelection";
import SuperAdmin from "./SuperAdmin";
import OrganizationList from "./OrganizationList";
import { connect } from "react-redux";
import { enableFamilyInviteV2Flow } from "config";
import { localeParamsHelper, branch } from "Utils";
import {
  clearToast,
  checkAuthentication,
  starChatWidgetForVisitors,
  isPublicPlatformRoute,
  isPageNotFoundRoute,
  isUserLoggedOut,
  isMigrationInProgressRoute,
  isPublicSSORoute,
  setPublicToken,
  isUserBlockedRoute,
  isPublicSchoolLoginPage,
  isPublicToddleAppLaunchRoute,
  isPublicAppDownloadRoute,
  isPublicMobileUnsupportedRoute,
  isSessionRevokeRoute,
} from "Login/modules/LoginModule";
import { setIsOnline, setIsPageNotFound } from "modules/Services";
import {
  handleQueryParameters,
  goToBack,
  updateQueryParameters,
  goToPageNotFound,
} from "modules/NavigationModule";
import PageNotFound from "AppComponents/PageNotFound";
import MigrationInProgress from "AppComponents/MigrationInProgress";
import { Button } from "@toddle-edu/ds-web";
import { Trans } from "react-i18next";
import { isInKioskMode } from "Utils/DeviceDetectHelpers";

const LoginLoadingStyle = {
  backgroundColor: `rgba(0,0,0, 0.5)`,
};

const LoginLoadingStyleWebView = {
  backgroundColor: `white`,
};

class LoginView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toastrRef = null;
    this.persistentNotificationRef = null;
    this.state = {
      isGlobalTrayVisible: true,
    };
  }

  UNSAFE_componentWillMount = () => {
    const {
      checkAuthentication,
      handleQueryParameters,
      location,
      updateQueryParameters,
    } = this.props;

    const query = location.query || {};

    let navigationPerformanceEntries = [];
    if (_.get(window, "performance.getEntriesByType")) {
      navigationPerformanceEntries = window.performance.getEntriesByType(
        "navigation"
      );
    }

    const hasReloadTypeInNavigationObject = _.includes(
      _.map(navigationPerformanceEntries, nav => _.get(nav, "type")),
      "reload"
    );

    if (isInKioskMode()) sessionStorage.setItem("appType", "cros");

    const { user_id } = query;
    let params = {};

    if (user_id) params = { id: user_id };

    // This function sets userLoggedIn inside redux which is used in handleQueryParameters
    // so make sure to keep this function above handleQueryParameters
    checkAuthentication(params);

    if (hasReloadTypeInNavigationObject && isUserLoggedOut()) {
      // While authentication process, if users reload in any screen, then we need to redirect to login home page to avoid issues of apis getting called with empty params
      if (!_.isEmpty(query)) {
        updateQueryParameters({
          params: {
            type: "loginHome",
          },
          paramsToBeRemoved: ["usertype", "role"],
        });
      }
    } else {
      handleQueryParameters({ query });
    }

    setTimeout(() => {
      this.setState({ run: true });
    }, 10000);
    starChatWidgetForVisitors();
  };

  getTransLocale = ({ msg, message_with_params }) => {
    return (
      <Trans
        i18nKey={msg}
        values={message_with_params}
        components={{ b: <b /> }}
      />
    );
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { t } = this.props;
    const { toast = {} } = nextProps || {};
    const {
      showToast,
      title,
      msg,
      notString,
      timeOut,
      locale_params,
      onClick,
      type,
      variant,
      isClosable,
      primaryAction,
      prefixIcon,
      hasHTMLTags,
      showIcon,
      persistent, // when true, routes to PersistentNotification instead of Toastr
      onDismiss, // optional callback invoked when a persistent notification is dismissed
      toastId, // optional custom ID for programmatic dismissal via toast.dismiss()
    } = toast || {};
    if (showToast && _.size(msg) != 0) {
      let message;
      if (toast.hasOwnProperty("notString")) {
        message = notString ? msg : t(msg);
      } else {
        message = t(msg);
      }
      if (!notString && hasHTMLTags) {
        message = this.getTransLocale({ msg });
      }
      if (toast.hasOwnProperty("locale_params")) {
        const message_with_params = localeParamsHelper({
          params: locale_params,
          t,
        });
        if (hasHTMLTags) {
          message = this.getTransLocale({ msg, message_with_params });
        } else message = t(msg, message_with_params);
      }

      const actions = primaryAction && (
        <Button
          dsVersion="2.0"
          type="outlined"
          variant="neutral"
          onClick={primaryAction.onClick}
          shouldStopPropagation={true}
        >
          {t(primaryAction.label)}
        </Button>
      );

      /* Route to PersistentNotification (separate component) when
         persistent flag is set, otherwise use the regular Toastr. */
      if (persistent) {
        const persistentActions = primaryAction && (
          <Button
            dsVersion="2.0"
            variant="progressive"
            size="small"
            onClick={primaryAction.onClick}
            shouldStopPropagation={true}
          >
            {t(primaryAction.label)}
          </Button>
        );
        const { showNotification } = this.persistentNotificationRef || {};
        if (showNotification) {
          showNotification({
            title,
            message,
            actions: persistentActions,
            prefixIcon,
            onDismiss, // pass through so PersistentNotification can call it on close
            toastId, // pass through for programmatic dismissal
          });
        }
      } else {
        const { showToast } = this.toastrRef || {};
        if (showToast) {
          showToast({
            title,
            message,
            type,
            variant,
            timeOut: timeOut || 2000,
            onClick,
            isClosable,
            actions,
            prefixIcon,
            showIcon,
          });
        }
      }
      this.props.clearToast();
    }
  }

  render() {
    let compToShow = null;
    const {
      isLoading,
      userLoggedIn,
      isSALoggedIn,
      location,
      isOnline,
      setIsOnline,
      isPageNotFound,
      isMigrationInProgress,
      toast,
      children,
      showPip,
      userType,
      isChildPresent,
      showOrganizationSwitcher,
      invitedFamilyData,
      isUserConfigurationsFetched,
      accessibleToken,
    } = this.props;

    const isPublicAccess = isPublicPlatformRoute();
    const showLoginPage =
      !userLoggedIn &&
      !isPublicAccess &&
      !isPublicSSORoute() &&
      !isPublicSchoolLoginPage() &&
      !isPublicToddleAppLaunchRoute() &&
      !isPublicAppDownloadRoute() &&
      !isPublicMobileUnsupportedRoute() &&
      !isSessionRevokeRoute();
    // showAddChildPage will only be visible to parent if no child Present
    const showAddChildPage =
      !showLoginPage &&
      userType === "parent" &&
      !isChildPresent &&
      _.isEmpty(invitedFamilyData) &&
      !isPublicAccess &&
      !isLoading;
    /**
     * isLoading condition is required to prevent any actions till loading is not completed.
     * This is required specifically for cache persistance as we need to block any cache update until cache persistance is not configured.
     * Same is true for showAddChildFamilyInvitePage
     */

    const showAddChildFamilyInvitePage =
      !showLoginPage &&
      userType === "parent" &&
      !_.isEmpty(invitedFamilyData) &&
      _.get(invitedFamilyData, "type") === "family_class_invite" &&
      !isLoading;

    const areChildrenShown =
      !showLoginPage &&
      !isLoading &&
      !showAddChildPage &&
      !showAddChildFamilyInvitePage &&
      _.isEmpty(invitedFamilyData);

    /**
     * We can't show FullScreenLoader when loading is going on otherwise 2 loaders will be shown.
     * To avoid FullScreenLoader on school login page for family invite need to check for isPublicSchoolLoginPage as well
     */
    const showFullScreenLoader =
      !_.isEmpty(invitedFamilyData) &&
      !(showLoginPage || isPublicSchoolLoginPage()) &&
      !showAddChildFamilyInvitePage &&
      !isLoading;

    const isSAPageShown = isSALoggedIn && !isLoading;

    if (showLoginPage) compToShow = <LoginPage location={location} />;
    if (showAddChildPage) {
      compToShow = enableFamilyInviteV2Flow ? (
        <AddChildPageV2 />
      ) : (
        <AddChildPage />
      );
    }
    if (showAddChildFamilyInvitePage) {
      compToShow = <ClassInviteChildSelection />;
    }

    if (areChildrenShown) {
      compToShow = (
        <React.Fragment>
          {isPublicAccess ||
          isPublicSSORoute() ||
          isPageNotFoundRoute() ||
          isMigrationInProgressRoute() ||
          isUserBlockedRoute() ||
          isPublicToddleAppLaunchRoute() ||
          isPublicAppDownloadRoute() ||
          isPublicMobileUnsupportedRoute() ||
          isSessionRevokeRoute() ? (
            children
          ) : isUserConfigurationsFetched ? (
            <>
              <ChildrenPage {...this.props} />
              {showPip ? <PictureInPicture /> : null}
            </>
          ) : null}
          {/* <MobileDevice goToBack={goToBack} currentRoute={currentRoute} /> */}
        </React.Fragment>
      );
    }
    if (isSAPageShown) compToShow = <SuperAdmin />;
    // }

    if (isMigrationInProgress && !showLoginPage) {
      compToShow = <MigrationInProgress {...this.props} />;
    }

    if (isPageNotFound) {
      compToShow = <PageNotFound />;
    }

    /**Organization switcher for users which are part
     * of more than one organization.
     * (Not to be confused with Super Admin Org selection screen)
     */
    if (showOrganizationSwitcher) {
      compToShow = <OrganizationList />;
    }

    /**
     * We will receive org workspace page (School specific login page) as children
     * and to prevent blank screen while loading and re-rendering of child, We need to show it while loading is going on
     */
    if (isPublicSchoolLoginPage() && _.isEmpty(accessibleToken)) {
      compToShow = children;
    }

    const isWorksheetWebView = _.includes(
      _.get(location, "search", ""),
      "isWorksheetWebView=true"
    );

    return (
      <div className={classes.wrapper}>
        {ACLStore.can("FeatureFlag:NetworkStatusV2") ? (
          <NetworkStatusV2 isOnline={isOnline} setIsOnline={setIsOnline} />
        ) : (
          <NetworkStatus isOnline={isOnline} setIsOnline={setIsOnline} />
        )}

        <Toastr
          ref={ref => {
            this.toastrRef = ref;
          }}
          {...toast}
        />
        {/* Separate persistent notification system — works in parallel with Toastr */}
        <PersistentNotification
          ref={ref => {
            this.persistentNotificationRef = ref;
          }}
        />
        <div className={classes.mainContainer}>
          {compToShow}
          {!!isLoading && (
            <div
              className={classes.fullScreenLoaderContainer}
              style={
                userLoggedIn
                  ? {}
                  : isWorksheetWebView
                  ? LoginLoadingStyleWebView
                  : LoginLoadingStyle
              }
            >
              <Loading />
            </div>
          )}
        </div>
        {showFullScreenLoader && <FullScreenLoader />}
      </div>
    );
  }
}

const mapActionCreators = {
  checkAuthentication,
  clearToast,
  goToBack,
  handleQueryParameters,
  setIsOnline,
  setIsPageNotFound,
  updateQueryParameters,
  setPublicToken,
  goToPageNotFound,
};

const BLANK_OBJECT = {};
const mapStateToProps = (state, ownProps) => {
  const userType = state.login.userInfo.user_type;

  return {
    isOnline: state.app_services.isOnline,
    isPageNotFound: state.app_services.isPageNotFound,
    isMigrationInProgress: isMigrationInProgressRoute(),
    isSALoggedIn: state.login.sa.loggedIn,
    userLoggedIn: state.login.userLoggedIn,
    userType,
    isChildPresent: state.login.isChildPresent,
    isLoading: state.login.isLoading,
    currentRoute: _.get(_.last(_.get(ownProps, "routes", [])), "path", ""),
    toast: _.get(state, "login.toast", BLANK_OBJECT),
    showPip: _.get(state, "app_services.pictureInPictureConfig.showPip", false),
    showOrganizationSwitcher: _.get(
      state,
      "login.organizationSwitcherDetails.isVisible",
      false
    ),
    invitedFamilyData: state.login.invitedFamilyData,
    isUserConfigurationsFetched: _.get(
      state,
      "login.isUserConfigurationsFetched",
      false
    ),
    publicToken: _.get(state, "login.publicToken"),
    accessibleToken: _.get(state, "login.userInfo.token", ""),
    idpCode: _.get(state, "login.userInfo.idpCode", ""),
  };
};

export default compose(
  I18nHOC({ resource: ["common", "toastMsgs"] }),
  withRouter,
  connect(mapStateToProps, mapActionCreators),
  branch(() => isPublicPlatformRoute(), withPublicToken)
)(LoginView);
